import { useParams } from "react-router-dom";
import BlogContent from "../components/blogs/BlogContent";
import { sampleBlogs } from "../components/blogs/blogs";
import Seo from "../seo/Seo";
import { seoContent } from "../seo/seoContent";
import NotFoundPage from "./NotFoundPage";

// SEO metadata for each blog post, keyed by its slug in blogs.js
const blogSeo = {
  "what-is-avgc-xr-in-india": seoContent.blogAvgcXr,
  "what-if-film-school-and-film-studio-were-same-company":
    seoContent.blogFilmSchoolAndStudio,
  "ai-can-make-movies-but-can-it-ever-replace-filmmakers":
    seoContent.blogAiFilmmakers,
};

export default function BlogPostPage() {
  const { slug } = useParams();
  const blog = sampleBlogs.find((entry) => entry.slug === slug);

  if (!blog) return <NotFoundPage />;

  return (
    <>
      {blogSeo[slug] && <Seo {...blogSeo[slug]} />}
      <BlogContent blog={blog} />
    </>
  );
}
